(function () {
  'use strict';

  function FaqSearch(sectionId) {
    this.sectionId = sectionId;
    this.input = document.querySelector('[data-faq-search-input="' + sectionId + '"]');
    this.clearBtn = document.querySelector('[data-faq-search-clear="' + sectionId + '"]');
    this.noResults = document.querySelector('[data-faq-no-results="' + sectionId + '"]');
    this.status = document.querySelector('[data-faq-search-status="' + sectionId + '"]');
    this.container = this.input && this.input.closest('.faq-metaobjects');

    if (!this.input || !this.container) return;

    this.input.addEventListener('input', this._onInput.bind(this));
    this.clearBtn && this.clearBtn.addEventListener('click', this._onClear.bind(this));
  }

  FaqSearch.prototype._onInput = function () {
    var query = this.input.value.trim().toLowerCase();
    this._filter(query);
    if (this.clearBtn) {
      this.clearBtn.classList.toggle('d-none', query === '');
    }
  };

  FaqSearch.prototype._onClear = function () {
    this.input.value = '';
    this._filter('');
    if (this.clearBtn) this.clearBtn.classList.add('d-none');
    this.input.focus();
  };

  FaqSearch.prototype._filter = function (query) {
    var items = this.container.querySelectorAll('[data-faq-search]');
    var categories = this.container.querySelectorAll('.faq-category');
    var visibleCount = 0;

    if (query === '') {
      items.forEach(function (item) {
        item.classList.remove('d-none');
      });
      categories.forEach(function (cat) {
        cat.classList.remove('d-none');
      });
      if (this.noResults) this.noResults.classList.add('d-none');
      if (this.status) this.status.textContent = '';
      return;
    }

    items.forEach(function (item) {
      var text = item.dataset.faqSearch || '';
      var matches = text.includes(query);
      item.classList.toggle('d-none', !matches);
      if (matches) visibleCount++;
    });

    categories.forEach(function (cat) {
      var hasVisible = cat.querySelector('[data-faq-search]:not(.d-none)') !== null;
      cat.classList.toggle('d-none', !hasVisible);
    });

    if (this.noResults) {
      this.noResults.classList.toggle('d-none', visibleCount > 0);
    }

    if (this.status) {
      this.status.textContent = visibleCount > 0
        ? visibleCount + ' résultat' + (visibleCount > 1 ? 's' : '')
        : 'Aucun résultat';
    }
  };

  function init() {
    var inputs = document.querySelectorAll('[data-faq-search-input]');
    inputs.forEach(function (input) {
      new FaqSearch(input.dataset.faqSearchInput);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
